<template>
  <div>
    <div>Milestones</div>

    <ul>
      <li v-for="milestone in this.milestones"
:key="milestone.id">
        <p>{{ formatDate(milestone.date) }}</p>
        <h2>{{ milestone.title }}</h2>
      </li>
    </ul>
  </div>
</template>

<script>
import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
export default {
  name: 'CompetitionEditMilestones',
  computed: {
    milestones() {
      return this.state.milestones
    }
  },
  methods: {
    formatDate(date) {
      return format(parseISO(date), 'do MMMM yyyy')
    }
  }
}
</script>